import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * The page title, set on the paper like a section head on teral.dev. It keeps
 * the page's measure so it lines up with the body below.
 */
function PageHeader({ className, children, ...props }: React.ComponentProps<"div">) {
  return (
    <div className={cn("relative w-full", className)} {...props}>
      <div
        className={cn(
          "mx-auto flex w-full max-w-6xl flex-wrap items-end justify-between gap-x-4 gap-y-3 px-6 pt-10 pb-1",
          "group-data-[width=full]/page:max-w-none",
        )}
      >
        {children}
      </div>
    </div>
  );
}

function PageHeaderContent({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("flex flex-col gap-0.5 min-w-0", className)} {...props} />;
}

function PageHeaderTitle({ className, ...props }: React.ComponentProps<"h1">) {
  return (
    <h1
      className={cn("m-0 font-display text-[1.75rem] leading-[2.125rem] text-gray-12", className)}
      {...props}
    />
  );
}

function PageHeaderDescription({ className, ...props }: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="page-header-description"
      className={cn("m-0 mt-1 max-w-[60ch] text-sm leading-5 text-gray-11", className)}
      {...props}
    />
  );
}

function PageHeaderActions({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("flex flex-wrap items-center gap-2 shrink-0", className)} {...props} />;
}

export { PageHeader, PageHeaderContent, PageHeaderTitle, PageHeaderDescription, PageHeaderActions };
